import React, { useState } from 'react';
import { Stack, TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';

import { AddButton } from '../../components/common/button/CustomButtons';
import ChildHeader from '../../components/ui/ChildHeader';
import { SearchFilterContainer } from '../../assets/styles/layout/searchFilter.styled';
import FilterBy from '../../components/common/FilterBy';
import { SearchBar } from '../../components/common/SearchBar';
import { TableCustom } from '../../components/common';
import useDebounce from '../../hooks/useDebounce';
import {
  EditIconButton,
  DeleteIconButton,
  ViewIconButton,
} from '../../components/common/button/CustomIconButton';

import { useQuery } from '../../hooks/UseQuery';
import useConfirm from '../../components/common/useConfirm';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import formatDate from '../../components/common/formatDate';
import CustomUploadButton from '../../components/common/button/CustomUploadButton';
const tableHeaderObj = [
  [
    { text: 'S.No.', rowspan: 1, colspan: 1 },
    { text: 'Part Name', rowspan: 1, colspan: 1 },
    { text: 'Part Number', rowspan: 1, colspan: 1 },
    { text: 'Operation Name', rowspan: 1, colspan: 1 },
    { text: 'Operation No', rowspan: 1, colspan: 1 },
    { text: 'Created At', rowspan: 1, colspan: 1 },
    { text: 'Operation Photo', rowspan: 1, colspan: 1 },
    { text: 'Action', rowspan: 1, colspan: 1 },
  ],
];

const filterOptions = [{ value: 'createdAt', name: 'A-Z' }];

const List = () => {
  const [data, setData] = useState<any[]>([]);
  const [isModal, setIsModal] = useState<boolean>(false);
  const [render, setRender] = useState(false);
  const [customerId, setCustomerId] = useState<string | null>(null);
  const [perPage, setPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState(0);
  const navigate = useNavigate();
  const search = useQuery('search');
  const filter = useQuery('filter');
  const page = useQuery('page') || 1;
  const { partId } = useParams();
  const partName = useQuery('part_name');
  const partNumber = useQuery('part_number');

  const [DialogDelete, confirmDelete] = useConfirm(
    'DELETE SUPPLIER',
    'Are you sure you want to delete this?',
  );

  const fetchData = async () => {
    const res = await axios
      .get(
        `/api/processControlRoute/byPartId/${partId}?page=${page}&sortBy=${filter}&search=${search}&perPage=${perPage}`,
      )
      .catch((err) => {
        console.log(err);
      });
    setData(res?.data?.results);
    setPerPage(res?.data?.perPage);
    setTotalPages(res?.data?.pages);
  };

  const deleteList = async (id: string) => {
    const ans = await confirmDelete();
    if (!ans) return;
    await axios
      .delete(`/api/processControlRoute/${id}`)
      .then((res) => {
        alert('Document deleted successfully');
        setRender((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  useDebounce(fetchData, 500, [page, search, render, isModal]);

  const uploadImage = async (id: string, image: any) => {
    if (!window.confirm('Are you sure you want to upload this image?')) return;
    if (!image) alert('please choose image');
    const formData = new FormData();
    formData.append('image', image);
    axios
      .patch(`/api/processControlRoute/uploadImage/${id}`, formData)
      .then((res) => {
        alert('image upload successfully');
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <ChildHeader text="PROCESS CONTROL STANDARD LIST">
        <AddButton
          onClick={() =>
            navigate(
              `/common/processControlStandardCreate/${partId}?part_name=${partName}&part_number=${partNumber}`,
            )
          }
          label="New Process Standard"
        />
      </ChildHeader>
      <SearchFilterContainer filter={true}>
        <SearchBar label="Search" />
        <FilterBy options={filterOptions} />
      </SearchFilterContainer>
      <TableCustom tableHeaderObj={tableHeaderObj}>
        <TableBody>
          {data &&
            data.map((item: any, index: number) => (
              <React.Fragment>
                <TableRow>
                  <TableCell align="center">
                    {perPage * (+page - 1) + index + 1}
                  </TableCell>

                  <TableCell align="center">{partName}</TableCell>
                  <TableCell align="center">{partNumber}</TableCell>
                  <TableCell align="center">{item.process_name}</TableCell>
                  <TableCell align="center">{item?.process_no}</TableCell>
                  <TableCell align="center">
                    {formatDate(item?.createdAt || '')}
                  </TableCell>
                  <TableCell align="center">
                    <CustomUploadButton
                      lable={'UPLOAD IMAGE'}
                      id={`process_control_standard ${index}`}
                      accept="image/png,image/jpeg,image/jpg"
                      onChange={(e) =>
                        uploadImage(item?._id, e.target.files[0])
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <Stack direction="row" sx={{ justifyContent: 'center' }}>
                      <ViewIconButton
                        tooltipTitle="view"
                        onClick={() => {
                          navigate(
                            `/common/processControlStandardCreate/${partId}/${item?._id}?part_name=${partName}&part_number=${partNumber}&isView=true`,
                          );
                        }}
                      />

                      <EditIconButton
                        tooltipTitle="EDIT"
                        onClick={() => {
                          navigate(
                            `/common/processControlStandardCreate/${partId}/${item?._id}?part_name=${partName}&part_number=${partNumber}&isView=false`,
                          );
                        }}
                      />

                      <DeleteIconButton
                        tooltipTitle="DELETE"
                        onClick={() => {
                          deleteList(item?._id || '');
                        }}
                      />
                    </Stack>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
        </TableBody>
      </TableCustom>

      <DialogDelete isSubmitContent={false} />
    </>
  );
};

export default List;
